export default __webpack_public_path__ + "static/media/CMS_Report.d9959b1a.svg";